import { fetchSyncServices } from '@/api/sync'

const state = {
  isLoading: false,
  syncServices: [],
  syncResourceWarningThresholdPercent: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchSyncServices ({ dispatch, commit }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      const syncServicesResponse = await fetchSyncServices(payload)

      commit('setSyncServices', syncServicesResponse.data)
      commit(
        'setSyncResourceWarningThresholdPercent',
        syncServicesResponse.syncResourceWarningThresholdPercent
      )
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.isLoading = false
    state.syncServices = []
    state.syncResourceWarningThresholdPercent = null
  },

  setSyncServices (state, syncServices) {
    state.syncServices = syncServices
  },

  setSyncResourceWarningThresholdPercent (state, thresholdPercent) {
    state.syncResourceWarningThresholdPercent = thresholdPercent
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
